import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  grey1,
  grey4,
  grey5,
  grey6,
  grey8,
  grey9,
  grey10,
  purple1,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  fontFamilyBase,
  fontWeightMedium,
  fontWeightNormal,
  fontSize16,
  fontSize16LineHeight,
} from 'approot/shared/styles/typography.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import {
  standardBorderRadius,
  standardFocusState,
  baseBoxShadowFocus,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/buttons';

export const DatePickerStyled = styled.div`
  .rdp-months {
    ${boxShadowBlack12}
    ${standardBorderRadius}

    background-color: ${grey1};
    border: 1px solid ${grey4};
    display: flex;
    flex-direction: column;
    font-family: ${fontFamilyBase};
    padding-bottom: 0;
    position: relative;

    ${mediaUp.sm`
      flex-direction: row;
    `}

    &:focus {
      box-shadow: ${baseBoxShadowFocus};
      outline: 0;
    }
  }

  .rdp-vhidden {
    display: none !important;
  }

  .rdp-caption {
    border-bottom: 1px solid ${grey4};
    color: ${grey10};
    display: flex;
    font-size: ${rem(fontSize16)};
    font-weight: ${fontWeightMedium};
    align-items: center;
    justify-content: center;
    line-height: ${rem(fontSize16LineHeight)};
    margin: 0;
    height: ${rem(52)};
    padding: 0 ${rem(spacing16)};
    position: relative;
    text-align: center;

    .rdp-caption_label {
      color: ${grey8};
      font-size: ${rem(fontSize16)};
      font-weight: ${fontWeightNormal};
      margin: 0;
    }
  }

  .rdp-nav {
    display: flex;
    position: absolute;
    left: ${rem(spacing16)};
    right: ${rem(spacing16)};
    top: ${rem(spacing16)};

    .rdp-nav_button {
      height: ${rem(24)};
      width: ${rem(24)};
      position: absolute;

      &:hover {
        background-color: ${purple1};
        cursor: pointer;
      }

      ${standardFocusState}

      svg {
        width: ${rem(12)};
        height: ${rem(12)};
      }

      &.rdp-nav_button_next {
        right: 0;
      }
    }

    .rdp-nav_button[aria-disabled='true'] {
      background-color: ${grey4};
      color: ${grey6};

      &:hover {
        cursor: not-allowed;
      }
    }
  }

  .rdp-row {
    padding: 0 ${rem(spacing16)};

    &:last-child {
      padding-bottom: ${rem(spacing16)};
    }
  }

  .rdp-row,
  .rdp-head_row {
    display: flex;
    margin: 0;
  }

  .rdp-head_row {
    padding: ${rem(spacing16)};
  }

  .rdp-head_cell {
    color: ${grey9};
    display: block;
    font-size: ${rem(14)};
    font-weight: normal;
    padding: 0;
    width: ${rem(28)};
    text-align: center;
  }

  .rdp-cell {
    background-color: transparent;
    margin: 0;
    padding: 0;
    position: relative;
    width: ${rem(28)};
    text-align: center;
  }

  .rdp-button {
    background-color: transparent;
    border-radius: ${rem(32)};
    border: none;
    height: ${rem(28)};
    padding: ${rem(2)};
    width: ${rem(28)};

    span {
      border-radius: ${rem(24)};
      color: ${grey8};
      display: block;
      font-size: ${rem(12)};
      font-family: ${fontFamilyBase};
      height: ${rem(24)};
      line-height: ${rem(24)};
      margin: 0;
      padding: 0;
      position: relative;
      width: ${rem(24)};
    }

    &:hover span {
      background-color: ${purple1};
      cursor: pointer;
    }

    &:focus {
      outline: 0;
      span {
        box-shadow: ${baseBoxShadowFocus};
      }
    }
  }

  .rdp-day_selected {
    background-color: ${purple1};
    border-radius: 0;
    &:hover {
      background-color: ${purple1};
    }
  }

  .rdp-day_disabled {
    span {
      background-color: transparent;
      color: ${grey5};
    }

    &:hover span,
    span:hover {
      background-color: transparent;
      cursor: not-allowed;
    }
  }

  // range picker styles
  .rdp-day_range_start,
  .rdp-day_range_end {
    background-color: ${purple1};
    span {
      background-color: ${purple7};
      color: ${grey1};
    }
    &:hover {
      background-color: ${purple1};
      span {
        background-color: ${purple7};
        cursor: pointer;
      }
    }
  }

  .rdp-day_range_start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }

  .rdp-day_range_end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }

  .rdp-day_range_start.rdp-day_range_end {
    background-color: transparent;
  }
`;

export const DatePickerFieldTriggerStyled = styled.div`
  display: flex;
  flex-direction: column;

  ${SecondaryButton} {
    justify-content: left;
  }
`;

export const DatePickerPopper = styled.div`
  // positioning styles added by popper
  z-index: 100;
`;
